import DepartmentContactBlock from '../DepartmentContactBlock/DepartmentContactBlock.jsx';
import { Icon, LoadingCircle, ResponsiveGrid } from '@gplibraries/react/components';
import { Link } from 'react-router';
import { useQuickLinks } from '@gplibraries/react/hooks';

export default function ResourceTabsContent(props) {

  const { resources, resourceSubcategories, activeTab, className = '' } = props;
  const { quickLinks, addQuickLink, removeQuickLink, inProgress } = useQuickLinks();

  return (
    <div className={`resource-content-container ${className}`}>

      <div className="resource-content flex-col">

        <DepartmentContactBlock departmentId={activeTab}/>

        <ResponsiveGrid minColumnWidth={'max(260px, 32%)'}  className={'start'} gap={'1rem'}>

          {resourceSubcategories
            .sort((a, b) => a.weight - b.weight)
            .map(subcategory => (
              <div className={'resource-group'} key={subcategory.id}>
                {/* Here we are hiding the subcategory name if it is the same as
                the parent category name. */}
                {subcategory.name.toLowerCase() !== subcategory.parent?.name?.toLowerCase() &&
                  <div className="resource-group-name">
                    <h3>{subcategory.name}</h3>
                  </div>
                }
                <ul className={'no-marker'}>
                  {resources
                    .filter(item => item?.category?.map(c => c.id).includes(subcategory.id))
                    .sort((a, b) => a?.field_weight - b?.field_weight)
                    .map(resource => (
                      <li key={resource.id} className={'resource-link flex-row'}>
                        {quickLinks?.find(item => item.id === resource.id)
                          ? (
                            <button
                              className="icon-only hyperlink"
                              onClick={!inProgress ? () => removeQuickLink(resource.id) : null}>
                              {inProgress === resource.id ? <LoadingCircle className={'inherit'}/> : <Icon glyph={'dash-square-fill'}/>}
                            </button>
                          ) : (
                            <button
                              className="icon-only hyperlink"
                              onClick={!inProgress ? () => addQuickLink(resource.id, resource.type) : null}>
                              {inProgress === resource.id ? <LoadingCircle className={'inherit'}/> : <Icon glyph={'plus-square'}/>}
                            </button>
                          )
                        }
                        <Link to={resource.field_url} className={'flex-inline'} reloadDocument={true}>{resource.title}</Link>
                      </li>
                    ))
                  }
                </ul>
              </div>
            ))
          }

        </ResponsiveGrid>

      </div>
    </div>
  );
}